import { deleteApi, get, post } from "../GenericServices";

const FlatRatePeriod = {
  getFlatRatePeriods: (queryString) => {
    return get(`flat-rate-period${queryString !== "" ? `?${queryString}` : ""}`);
  },
  getFlatRatePeriod: (id) => {
    return get(`flat-rate-period/${id}`);
  },
  setFlatRatePeriod: (data) => {
    return post(`flat-rate-period`, data);
  },
  deleteFlatRatePeriod: (id) => {
    return deleteApi(`flat-rate-period/${id}`);
  },
};

export default FlatRatePeriod;
